import { get, map, orderBy, pipe, toPairs } from 'lodash/fp'

export const getReferralTypes = pipe(
  get(['firebase', 'data', 'referralTypes']),
  toPairs,
  map(([referralTypeID, value]) => ({ ...value, referralTypeID })),
  orderBy(['title'], ['asc'])
)
